module.exports = __webpack_public_path__ + "images/pages/lp/down_arrow_2_d9182d617183f00a65a9ddd858e261cb.png";